import { EmoticonDeadOutlineIcon } from './EmoticonDeadOutlineIcon';

/**
 * author: Google
 * id 47AD308C-C9D8-43DB-8E92-B0FB02B906CF
 * name emoticon-dead-outline
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-dead-outline.svg
 * tags
 * - Emoji 
 */
export const FaceDeadOutlineIcon = EmoticonDeadOutlineIcon;
export default FaceDeadOutlineIcon